import axios from 'axios';
import { constant } from '@app/utils/constant';
import Cookies from 'js-cookie';

export const getPermission = async (filter: any) => {
  const BearerToken = Cookies.get(constant.Cookie_Name);
  let queryString = 'per_page=5000';
  if (filter.month) {
    queryString += '&MONTH=' + filter.month;
  }
  if (filter.year) {
    queryString += '&YEAR=' + filter.year;
  }
  let restype = 'json';
  try {
    const response = await axios.get(constant.API_BASEPATH + '/permissions?' + queryString, { headers: { "Authorization": `Bearer ${BearerToken}` }, responseType: restype });
    return response;
  } catch (err) {
    console.log(err);
  }
};


export const getPermissionById = async (id: number) => {
  const BearerToken = Cookies.get(constant.Cookie_Name);
  try {
    const response = await axios.get(constant.API_BASEPATH + '/permissions/' + id, { headers: { "Authorization": `Bearer ${BearerToken}` } });
    return response;
  } catch (err) {
    console.log(err);
  }
};

export const savePermissionData = async (data: any) => {
  const BearerToken = Cookies.get(constant.Cookie_Name);
  try {
    const response = await axios.post(constant.API_BASEPATH + '/permissions', data, { headers: { "Authorization": `Bearer ${BearerToken}` } });
    return response;
  } catch (err) {
    console.log(err);
    return { 'data': err.response.data };
  }
};

export const updatePermissionData = async (id: number, data: any) => {
  const BearerToken = Cookies.get(constant.Cookie_Name);
  try {
    const response = await axios.put(constant.API_BASEPATH + '/permissions/' + id, data, { headers: { "Authorization": `Bearer ${BearerToken}` } });
    return response;
  } catch (err) {
    console.log(err);
    return { 'data': err.response.data };
  }
};

export const deletePermission = async (id: number) => {
  const BearerToken = Cookies.get(constant.Cookie_Name);
  try {
    const response = await axios.delete(constant.API_BASEPATH + '/permissions/' + id, { headers: { "Authorization": `Bearer ${BearerToken}` } });
    return response;
  } catch (err) {
    console.log(err);
  }
};






